//  METADATA_TYPE const has the different kinds(or say types) of metadata that p_search accepts as payload for source, tagged_date etc
//  3-char number where -
//  1st char 1= string, 2= date, 3=year
//  2nd char 0= plain string 1= array
//  3rd char 0= take whole text as plain type, 1 = take from and to as separate types
//  say for example data is ["2010-05-09", "2011-05-11"] then kind = FROM_TO_DATE_ARRAY which is 211 where 2= date, 1= array, 1= from and to
const METADATA_TYPE = {
	STRING_VAL: 100,
	STRING_ARRAY: 110,
	DATE: 200,
	DATE_ARRAY: 210,
	FROM_TO_DATE_ARRAY: 211,
	YEAR: 300,
	YEAR_ARRAY: 310,
	FROM_TO_YEAR_ARRAY: 311,
}

// Need to check if this will be dynamic-whether we have to fetch from /info api call or is it always going to be kb or combined
const KNOWLEDGE_BASES = {
	COMBINED: "combined",
	KB: "kb",
}

const LOCAL_STORAGE_KEYS = {
	SELECTED_PROJECT: "selectedProject",
	USER: "user",
	TRIGGER_P_SEARCH: "triggerPSearch",
}

const SORT_ORDER = {
	ASCENDING: "asc",
	DESCENDING: "desc",
}

const GET_ALL_DATA_INTERVAL = 5 * 60 * 1000 //5 MIN

const PAGINATION_DELAY = 1500

const METADATA = {
	TAG: "tags",
	COMMENT: "comments_count",
	DATE: "tagged_date",
}

const DEFAULT_SOURCES = ["doc", "docx", "email", "pdf", "txt", "xls", "ppt"]

const RECORDS_PER_PAGE = 20

const DATE_FORMAT = "DD MMM, YYYY"
const PAYLOAD_DATE_FORMAT = "YYYY-MM-DD"
const DATE_PICKER_FORMAT = "DD/MM/yyyy"
const REVIEW_DETAIL_DATE_FORMAT = "DD MMM YYYY"
const TAGGED_DATE_FORMAT = "DD/MM/YYYY, hh:mm A"

const SOURCE_TYPE = {
	PDF: "pdf",
	EMAIL: "email",
	XLS: "xls",
	XLSX: "xlsx",
	DOC: "doc",
	DOCX: "docx",
	TXT: "txt",
	PPT: "ppt",
	HTML: "html",
	JPEG: "img",
	VIDEO: "video",
	AUDIO: "audio",
}

const STATUS = {
	CREATED: "Created",
	QUEUED: "Queued",
	IN_PROGRESS: "In-progress",
	COPYING: "Copying",
	DETECTING_DUPLICATE_FILES: "Detecting-duplicate-files",
	PII_EXTRACTION: "pii_extraction",
	SUCCESSFUL: "Successful",
	SUCCEEDED: "Succeeded",
	PARTIALLY_SUCCESSFUL: "Partially-successful",
	FAILED: "Failed",
	TEXT_EXTRACTED: "Text_extracted",
	TEXT_EXTRACTION: "Extracting-text",
	PII_EXTRACTION: "Extracting-PII-names",
	UNSUCCESSFUL: "Unsuccessful",
	POST_PROCESSING: "Post-processing",
	COPIED: "Copied",
	MARKED: "Marked",
	DONE: "Done",
	MARKED: "Marked",
	FAILED: "Failed",
	NOT_DONE: "Not-done",
	DONE: "Done",
	QUEUED: "Queued",
	REVERTED: "Reverted",
	SKIPPED: "Skipped",
	ACTIVE: "Active",
	MAINTENANCE: "Maintenance",
}

const CASE_ACTIVITY = {
	IDLE: "Idle",
	EXTRACTING: "Extracting",
	UPLOADING: "Uploading",
	KB_MAKING: "KB-making",
	ARCHIEVE: "Archieved",
	SOFT_DELETE: "Soft-deleted",
	HARD_DELETE: "Hard-deleted",
}

const DEFAULT_PAGE_SIZE = 20
const PAGE_OPTIONS = [10, 20, 50]
const ANNO_BG_COLOR = "rgb(63, 237, 199)"

const CONTEXT_TYPE = {
	FILE: "file",
	SEARCH: "named_search",
	REVIEW: "review",
}

const LIST_VIEW = "LIST"
const DETAIL_VIEW = "DETAIL"

const INACTIVE_CASE_STATUS = ["Archieved", "Soft-deleted", "Hard-deleted"]

const VIEWED_FILTER_KIND = {
	default: -1,
	viewed: 500,
	not_viewed: 0,
}

const GRAPH_DATE_OPTIONS = {
	SLIDER: "sliderPicker",
	GRAPH_PICKER: "graphPicker",
}

const GET_LATEST_FILES_SORT = { field: "file_id", ordering: 0, sort: "desc" }

export {
	METADATA_TYPE,
	KNOWLEDGE_BASES,
	LOCAL_STORAGE_KEYS,
	SORT_ORDER,
	GET_ALL_DATA_INTERVAL,
	METADATA,
	DEFAULT_SOURCES,
	PAGINATION_DELAY,
	RECORDS_PER_PAGE,
	DATE_FORMAT,
	PAYLOAD_DATE_FORMAT,
	SOURCE_TYPE,
	DEFAULT_PAGE_SIZE,
	PAGE_OPTIONS,
	STATUS,
	DATE_PICKER_FORMAT,
	CASE_ACTIVITY,
	REVIEW_DETAIL_DATE_FORMAT,
	CONTEXT_TYPE,
	LIST_VIEW,
	DETAIL_VIEW,
	ANNO_BG_COLOR,
	INACTIVE_CASE_STATUS,
	VIEWED_FILTER_KIND,
	GRAPH_DATE_OPTIONS,
	TAGGED_DATE_FORMAT,
	GET_LATEST_FILES_SORT,
}
export const drawerWidth = 250

//TODO: Need to come from backend
export const supportedOCRLanguage = [
	{ label: "English", value: "eng" },
	{ label: "Norwegian", value: "nor" },
	{ label: "Danish", value: "dan" },
	{ label: "Swedish", value: "swe" },
	{ label: "Italian", value: "ita" },
]

export const LAST_OPENED_FILE_ID = "lofi"

export const JOB_TYPES = [
	"Text-summary-extract",
	"Revert-text-summary-extract",
	"PII-extract",
	"Revert-PII-extract",
	"native-convert",
	"Revert-Native-convert",
]

export const CASE_JOB_ACTIONS = [
	{
		summary_extract: { job: "summary_extract", type: JOB_TYPES[0] },
		revert_summary_extract: { job: "revert_summary_extract", type: JOB_TYPES[1] },
		pii_extract: { job: "pii_extract", type: JOB_TYPES[2] },
		revert_pii_extract: { job: "revert_pii_extract", type: JOB_TYPES[3] },
		pdf_convert: { job: "pdf_convert", type: JOB_TYPES[4] },
		revert_pdf_convert: { job: "revert_pdf_convert", type: JOB_TYPES[5] },
	},
]
